module.exports = __webpack_public_path__ + "static/media/klede-k.00421657.mp3";